import React from 'react';
import clsx from 'clsx';
import Footer from '../Footer';
import Header from '../Header';
import ProtectedHeader from '../ProtectedHeader';
import { pageGutter } from '../../styles/styles';
const BaseLayout = ({ children , isProtectedHeader = false}) => {
    return (
        <div className={clsx('bg-white dark:bg-gray-800', 'flex flex-col min-h-screen transition-colors duration-200 ease-in-out')}>
            {isProtectedHeader ? <ProtectedHeader /> : <Header />}
            {/* Main Content */}
            <main className={clsx('flex-1 w-full mx-auto max-w-screen-lg md:max-w-screen-xl lg:max-w-screen-2xl xl:max-w-screen-3xl', pageGutter)}>{children}</main>
            <footer className="w-full mt-auto">
                <Footer />
            </footer>
        </div>
    );
};

export default BaseLayout;
